import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function AddWorkspace() {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [renewPopup, setRenewPopup] = useState(false);
  const [renewWorkspaceId, setRenewWorkspaceId] = useState("");
  const [editingWorkspace, setEditingWorkspace] = useState(null);
  const isEditMode = !!editingWorkspace;
  const [adsPlans, setAdsPlans] = useState([]);

  const [previewImage, setPreviewImage] = useState(null);
  const [freePlanPopup, setFreePlanPopup] = useState(false);
  const [allowFreePlanRequest, setAllowFreePlanRequest] = useState(false);
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [renewData, setRenewData] = useState({
    plan_id: "",
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });
  const openCarousel = (images, index = 0) => {
    setCarouselImages(images);
    setCurrentImageIndex(index);
    setShowCarousel(true);
  };

  const nextCarouselImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const prevCarouselImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showCarousel) return;

      if (e.key === "ArrowRight") {
        nextCarouselImage();
      }

      if (e.key === "ArrowLeft") {
        prevCarouselImage();
      }

      if (e.key === "Escape") {
        setShowCarousel(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showCarousel, carouselImages]);

  const [form, setForm] = useState({
    id: "",
    owner_name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    size: "",
    width: "",
    height: "",
    floor: "",
    rent_price: "",
    location: "",
    description: "",
    images: [],
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });

  const [workspace, setWorkspace] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [tick, setTick] = useState(0);
  const [loading, setLoading] = useState(false);

  // Fetch Ads Plans
  useEffect(() => {
    fetch(`${API.GET_ADS_PLANS}&type=workspace`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAdsPlans(data.data);
        }
      });
  }, []);

  // Countdown Timer Interval
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Fetch Workspaces Data
  const fetchWorkspace = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user?.id) return;

    try {
      const res = await fetch(
        `${API.LIST_WORKSPACES}&user_id=${user.id}&t=${Date.now()}`,
      );
      const data = await res.json();

      const formattedData = Array.isArray(data)
        ? data.map((item) => ({
            ...item,
            images: item.image
              ? item.image.split(",").filter((img) => img && img.trim() !== "")
              : [],
          }))
        : [];

      setWorkspace(formattedData);
    } catch (error) {
      console.error(error);
    }
  };
  const [imageIndexes1, setImageIndexes1] = useState({});
  const nextImage1 = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current >= images.length - 1) {
      setImageIndexes1((prev) => ({
        ...prev,
        [item.id]: 0, // Go back to the first image
      }));
      return;
    }
    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage1 = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current === 0) return;

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  useEffect(() => {
    fetchWorkspace();
  }, [location.pathname]);

  // Sync existing data if forwarded via route state

  const isExpired = (item) => {
    if (!item.ads_end_date) return false;
    return new Date(item.ads_end_date).getTime() < Date.now();
  };

  const getTimeLeft = (expiryDate, status) => {
    if (status?.toLowerCase() === "pending") return null;
    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate.replace(" ", "T")).getTime();
    const diff = expiry - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);

    return `${days}d ${hours}h ${mins}m`;
  };

  const handleEdit = (item) => {
    setEditingWorkspace(item);

    setForm({
      id: item.id,
      owner_name: item.owner_name || "",
      phone: item.phone || "",
      address: item.address || "",
      city: item.city || "",
      state: item.state || "",
      width: item.size ? item.size.split("x")[0].trim() : "",
      height: item.size ? item.size.split("x")[1]?.trim() : "",
      floor: item.floor || "",
      rent_price: item.rent_price || "",
      location: item.location || "",
      description: item.description || "",
      images: item.image ? item.image.split(",") : [],
      show_ads_days: item.show_ads_days || "",
      ads_amount: item.ads_amount || "",
      payment_screenshot: null,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (name === "payment_screenshot") {
      setForm((prev) => ({ ...prev, payment_screenshot: e.target.files[0] }));
      return;
    }

    if (type === "file" && name === "images") {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;

      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

      // Check each image size
      const oversizedFile = files.find((file) => file.size > MAX_FILE_SIZE);

      if (oversizedFile) {
        setErrors((prev) => ({
          ...prev,
          images: `${oversizedFile.name} is larger than 5 MB`,
        }));

        // Reset file input
        e.target.value = null;
        return;
      }

      const currentImages = form.images || [];

      const existingFileNames = currentImages
        .map((img) => (img instanceof File ? img.name : img))
        .filter(Boolean);

      const newFiles = files.filter(
        (file) => !existingFileNames.includes(file.name),
      );

      // Maximum 6 images
      if (currentImages.length + newFiles.length > 6) {
        setErrors((prev) => ({
          ...prev,
          images: "Maximum 6 images allowed",
        }));

        e.target.value = null;
        return;
      }

      const combinedImages = [...currentImages, ...newFiles];

      setErrors((prev) => ({
        ...prev,
        images: "",
      }));

      setForm((prev) => ({
        ...prev,
        images: combinedImages,
      }));

      // Reset input so same file can be selected again
      e.target.value = null;
      return;
    }

    // if (name === "width" || name === "height") {
    //   if (!/^[0-9]{0,4}$/.test(value)) return;
    // }

    if (name === "width" || name === "height") {
      if (!/^[0-9]{0,4}$/.test(value)) return;

      if (Number(value) === 0 && value !== "") {
        setErrors((prev) => ({
          ...prev,
          size: `${name === "width" ? "Width" : "Height"} cannot be 0`,
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          size: "",
        }));
      }
    }
    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find(
        (p) => String(p.days) === String(value),
      );

      setForm((prev) => ({
        ...prev,
        show_ads_days: value,
        ads_amount: selectedPlan ? selectedPlan.amount : "",
      }));

      return;
    }

    // if (name === "show_ads_days") {
    //   const selectedPlan = adsPlans.find(
    //     (p) => String(p.days) === String(value),
    //   );
    //   setForm((prev) => ({
    //     ...prev,
    //     show_ads_days: value,
    //     ads_amount: selectedPlan ? selectedPlan.amount : "",
    //   }));
    //   return;
    // }

    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;
      if (value.length !== 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone number must be 10 digits",
        }));
      } else {
        setErrors((prev) => ({ ...prev, phone: "" }));
      }
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const removeImage = (index) => {
    const newImages = [...form.images];
    newImages.splice(index, 1);
    setForm({ ...form, images: newImages });

    if (newImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        images: "Please upload at least 1 image",
      }));
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this workspace?",
    );
    if (!confirmDelete) return;

    try {
      const formData = new FormData();
      formData.append("id", id);

      const res = await fetch(API.DELETE_WORKSPACE, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.status === "success") {
        alert("Workspace Deleted Successfully");
        setWorkspace((prev) => prev.filter((item) => item.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      alert("Server Error");
    }
  };

  const handleRenewChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find((p) => String(p.id) === String(value));

      setRenewData({
        ...renewData,
        plan_id: value,
        show_ads_days: selectedPlan ? selectedPlan.days : "",
        ads_amount: selectedPlan ? selectedPlan.amount : "",
      });

      return;
    }

    if (name === "payment_screenshot") {
      setRenewData({ ...renewData, payment_screenshot: files[0] });
      return;
    }
  };
  const getRenewWorkspace = () => {
    return workspace.find(
      (item) => String(item.id) === String(renewWorkspaceId),
    );
  };
  const handleRenewSubmit = async () => {
    if (!renewData.show_ads_days) {
      alert("Please select plan");
      return;
    }

    const currentWorkspace = getRenewWorkspace();

    const isSelectingAds =
      currentWorkspace?.status?.toLowerCase() === "pending";

    // ===============================
    // FREE PLAN
    // ===============================
    if (Number(renewData.ads_amount) === 0) {
      const fd = new FormData();

      fd.append("workspace_id", renewWorkspaceId);
      fd.append("days", renewData.show_ads_days);

      try {
        const res = await fetch(API.FREE_RENEW_WORKSPACE, {
          method: "POST",
          body: fd,
        });

        const data = await res.json();

        if (data.success) {
          alert(
            isSelectingAds
              ? "Ads Selected Successfully"
              : "Ads Renewed Successfully",
          );

          setRenewPopup(false);
          setRenewData({
            plan_id: "",
            show_ads_days: "",
            ads_amount: "",
            payment_screenshot: null,
          });

          fetchWorkspace();
        } else {
          alert(data.message);
        }
      } catch (error) {
        console.error(error);
        alert("Something went wrong");
      }

      return;
    }

    // ===============================
    // PAID PLAN
    // ===============================
    if (isSelectingAds) {
      startWorkspacePayment(
        renewWorkspaceId,
        renewData.ads_amount,
        renewData.show_ads_days,
      );
    } else {
      startWorkspaceRenewPayment(
        renewWorkspaceId,
        renewData.ads_amount,
        renewData.show_ads_days,
      );
    }
  };
  const startWorkspaceRenewPayment = async (workspaceId, amount, days) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const fd = new FormData();

      fd.append("user_id", user.id);
      fd.append("workspace_id", workspaceId);
      fd.append("amount", amount);
      fd.append("days", days);

      const res = await fetch(API.CREATE_WORKSPACE_RENEW_ORDER, {
        method: "POST",
        body: fd,
      });

      const order = await res.json();

      if (!order.success) {
        alert(order.message);
        return;
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: "INR",

        order_id: order.order_id,

        name: "Embroidery Bazar",

        description: "Workspace Ads Renewal",

        handler: async function (response) {
          const verify = await fetch(API.VERIFY_WORKSPACE_RENEW_PAYMENT, {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,
            }),
          });

          const result = await verify.json();

          if (result.success) {
            alert("Workspace Renewed Successfully");

            setRenewPopup(false);

            fetchWorkspace();
          } else {
            alert(result.message);
          }
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.open();
    } catch (error) {
      console.log(error);

      alert("Payment Error");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = JSON.parse(sessionStorage.getItem("user"));

    const fd = new FormData();

    fd.append("user_id", user.id);

    // Send all normal fields
    Object.keys(form).forEach((key) => {
      if (key !== "images" && key !== "payment_screenshot") {
        fd.append(key, form[key] ?? "");
      }
    });

    // ===============================
    // KEEP OLD IMAGES DURING UPDATE
    // ===============================
    if (isEditMode) {
      const oldImages = form.images.filter((img) => typeof img === "string");

      oldImages.forEach((img) => {
        fd.append("existing_images[]", img);
      });
    }

    if (
      (form.width && Number(form.width) <= 0) ||
      (form.height && Number(form.height) <= 0)
    ) {
      setErrors((prev) => ({
        ...prev,
        size: "Width and Height must be greater than 0",
      }));
      return;
    }

    if ((form.width && !form.height) || (!form.width && form.height)) {
      setErrors((prev) => ({
        ...prev,
        size: "Please enter both Width and Height",
      }));
      return;
    }

    // ===============================
    // NEW IMAGE UPLOAD
    // ===============================
    (form.images || []).forEach((img) => {
      if (img instanceof File) {
        fd.append("images[]", img);
      }
    });

    // Payment screenshot only for add
    if (form.payment_screenshot) {
      fd.append("payment_screenshot", form.payment_screenshot);
    }

    try {
      const res = await fetch(
        isEditMode ? API.UPDATE_WORKSPACE : API.ADD_WORKSPACE,
        {
          method: "POST",
          body: fd,
        },
      );

      const data = await res.json();

      if (data.status) {
        // ===============================
        // UPDATE SUCCESS
        // ===============================
        if (isEditMode) {
          alert("Workspace Updated Successfully");

          setEditingWorkspace(null);

          setForm({
            id: "",
            owner_name: "",
            phone: "",
            address: "",
            city: "",
            state: "",
            size: "",
            width: "",
            height: "",
            floor: "",
            rent_price: "",
            location: "",
            description: "",
            images: [],
            show_ads_days: "",
            ads_amount: "",
            payment_screenshot: null,
          });

          fetchWorkspace();

          return;
        }

        // ===============================
        // ADD FREE PLAN
        // ===============================
        alert(
          "Workspace Added Successfully. Complete payment after selecting Ads Plan.",
        );
        setForm({
          id: "",
          owner_name: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          size: "",
          width: "",
          height: "",
          floor: "",
          rent_price: "",
          location: "",
          description: "",
          images: [],
          show_ads_days: "",
          ads_amount: "",
          payment_screenshot: null,
        });

        fetchWorkspace();

        return;

        // ===============================
        // ADD PAID PLAN
        // ===============================
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);

      alert("Something went wrong");
    }
  };
  const startWorkspacePayment = async (workspaceId, amount) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const fd = new FormData();

      fd.append("user_id", user.id);
      fd.append("workspace_id", workspaceId);
      fd.append("amount", amount);

      const res = await fetch(API.CREATE_WORKSPACE_ORDER, {
        method: "POST",
        body: fd,
      });

      const order = await res.json();

      if (!order.success) {
        alert(order.message);
        return;
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: "INR",

        order_id: order.order_id,

        name: "Embroidery Bazar",

        description: "Workspace Advertisement",

        handler: async function (response) {
          const verify = await fetch(API.VERIFY_WORKSPACE_PAYMENT, {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,
            }),
          });

          const result = await verify.json();

          if (result.success) {
            alert("Payment Successful");

            fetchWorkspace();

            navigate("/user/workspace");
          } else {
            alert(result.message);
          }
        },

        modal: {
          ondismiss() {
            alert("Payment Cancelled");

            // Keep Pending

            fetchWorkspace();
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", () => {
        alert("Payment Failed");

        // still Pending

        fetchWorkspace();
      });

      rzp.open();
    } catch (err) {
      console.log(err);

      alert("Payment Error");
    }
  };
  const completeWorkspacePayment = async (item) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const fd = new FormData();

      fd.append("user_id", user.id);
      fd.append("workspace_id", item.id);
      fd.append("amount", item.ads_amount);

      const res = await fetch(API.CREATE_WORKSPACE_ORDER, {
        method: "POST",
        body: fd,
      });

      const order = await res.json();

      if (!order.success) {
        alert(order.message);
        return;
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: "INR",

        order_id: order.order_id,

        name: "Embroidery Bazar",

        description: "Workspace Advertisement Payment",

        handler: async function (response) {
          const verify = await fetch(API.VERIFY_WORKSPACE_PAYMENT, {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            }),
          });

          const result = await verify.json();

          if (result.success) {
            alert("Payment Completed Successfully");
            fetchWorkspace();
          } else {
            alert(result.message);
          }
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.open();
    } catch (error) {
      console.log(error);
      alert("Payment Error");
    }
  };
  const totalSqFt = Number(form.width || 0) * Number(form.height || 0);
  return (
    <div className="workspace-container">
      <h2 className="machine-title">
        {isEditMode ? "Update Workspace" : "Add Workspace"}
      </h2>

      <form onSubmit={handleSubmit} className="workspace-form">
        <div className="workspace-section1">
          <h3>Workspace Details</h3>
          <hr />
        </div>

        <div className="workspace-grid">
          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>Owner Name</label>
                <input
                  name="owner_name"
                  placeholder="Enter owner full name"
                  value={form.owner_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>Mobile Number</label>
                <input
                  name="phone"
                  placeholder="Enter mobile number (e.g. 9876543210)"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-3">
                <label>Office Address</label>
                <textarea
                  name="address"
                  placeholder="Enter full workspace address"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>Landmark</label>
                <input
                  name="location"
                  placeholder="Nearby landmark (e.g. Ring Road, Textile Market)"
                  value={form.location}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>City</label>
                <input
                  name="city"
                  placeholder="Enter city (e.g. Surat)"
                  value={form.city}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>State</label>
                <input
                  name="state"
                  placeholder="Enter state (e.g. Gujarat)"
                  value={form.state}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>Floor</label>
                <input
                  name="floor"
                  placeholder="e.g. 2nd Floor"
                  value={form.floor}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-wsmall">
                <label>Rent Price</label>
                <input
                  name="rent_price"
                  placeholder="Enter monthly rent (e.g. 15000)"
                  value={form.rent_price}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="workspace-field-small">
                <label>Plot Size (Feet)</label>

                <div className="double-input-group">
                  <input
                    type="number"
                    name="width"
                    value={form.width}
                    onChange={handleChange}
                    placeholder="Width (e.g. 20)"
                    required
                  />

                  <span className="double-input-separator">×</span>

                  <input
                    type="number"
                    name="height"
                    value={form.height}
                    onChange={handleChange}
                    placeholder="Length (e.g. 40)"
                    required
                  />
                </div>

                {form.width && form.height && (
                  <div
                    style={{
                      marginTop: "10px",
                      fontWeight: "600",
                      color: "#198754",
                      fontSize: "13px",
                      fontWeight: "800",
                    }}
                  >
                    Total Area: <strong>{totalSqFt}</strong> sq. ft.
                  </div>
                )}

                {errors.size && <span className="error">{errors.size}</span>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="workspace-field-3">
                <label>Description</label>
                <textarea
                  name="description"
                  placeholder="Describe workspace facilities, machines, electricity, parking etc."
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="workspace-field">
            <label>Upload Images (Max 6)</label>
            <input
              type="file"
              name="images"
              multiple
              accept="image/*"
              onChange={handleChange}
              disabled={form.images.length >= 6}
            />
            {errors.images && <span className="error">{errors.images}</span>}
          </div>

          <div className="workspace-preview">
            {form.images.map((img, index) => (
              <div key={index} className="workspace-preview-box">
                <img
                  src={
                    img instanceof File
                      ? URL.createObjectURL(img)
                      : `${UPLOADS.WORKSPACE_IMAGE}${img}`
                  }
                  alt="Preview"
                />
                <button type="button" onClick={() => removeImage(index)}>
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="workspace-action-row">
          {isEditMode && (
            <button
              type="button"
              className="btn-cancel-edit"
              onClick={() => {
                setEditingWorkspace(null);

                setForm({
                  id: "",
                  owner_name: "",
                  phone: "",
                  address: "",
                  city: "",
                  state: "",
                  size: "",
                  width: "",
                  height: "",
                  floor: "",
                  rent_price: "",
                  location: "",
                  description: "",
                  images: [],
                  show_ads_days: "",
                  ads_amount: "",
                  payment_screenshot: null,
                });
              }}
            >
              <i className="bi bi-x-circle me-2"></i> Cancel Edit
            </button>
          )}
          <button className="btn-submit-workspace" disabled={loading}>
            {loading
              ? "Processing..."
              : isEditMode
                ? "Update Workspace"
                : "Add Workspace"}
          </button>
        </div>
      </form>

      <div className="designs-grid">
        {workspace.length > 0 ? (
          workspace.map((item) => {
            const images = item.image
              ? item.image.split(",").filter((img) => img.trim() !== "")
              : [];

            return (
              <div className="design-card" key={item.id}>
                <div className="machine-img-container">
                  <img
                    src={`${UPLOADS.WORKSPACE_IMAGE}${images[imageIndexes1[item.id] || 0]}`}
                    alt="workroom"
                  />
                  {images.length > 1 && (
                    <>
                      {(imageIndexes1[item.id] || 0) > 0 && (
                        <button
                          className="img-arrow left-arrow"
                          onClick={(e) => prevImage1(e, item)}
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>
                      )}

                      <button
                        className="img-arrow right-arrow"
                        onClick={(e) => nextImage1(e, item, images)}
                      >
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </>
                  )}

                  {/* <div className="image-count">
        
                    {item.status}
                  </div> */}
                  <span
                    className={`bm_cardStatus ${item.status.toLowerCase()}`}
                  >
                    {item.status === "Hidden" ? "Hide" : item.status}
                  </span>
                  {/* <span className="heads-badge">{item.floor} </span> */}
                </div>

                <div className="machine-body">
                  <h4 className="machine-name">
                    {item.location || "Workspace Location"}
                  </h4>

                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="price-block">
                      <span className="currency-symbol">₹</span>
                      <span className="amount">
                        {Number(item.rent_price || 0).toLocaleString("en-IN")}
                      </span>
                    </div>
                    {/* <button className="contact-btn">
                      <i className="bi bi-telephone-fill me-1"></i> Contact
                    </button> */}
                  </div>

                  <div className="spec-row mt-0 ">
                    <div className="spec-item">
                      <span className="spec-label">Size: </span>
                      <span className="spec-value">{item.size}</span>
                    </div>
                    <div className="spec-item">
                      <span className="spec-label">Floor: </span>
                      <span className="spec-value">{item.floor}</span>
                    </div>
                  </div>

                  <div className="location-info">
                    <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                    {item.state}
                  </div>

                  {/* <div className="mt-2">
                    {!isExpired(item) && (
                      <span className={`status ${item.status?.toLowerCase()}`}>
                        {item.status}
                      </span>
                    )}
                    {isExpired(item) && (
                      <span className="status expired">Expired</span>
                    )}
                  </div> */}
                  <div className="machine-actions mt-3 d-flex gap-2">
                    <button
                      className="action-btn view-action"
                      onClick={() => setViewData(item)}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </button>
                    <button
                      className="action-btn edit-action"
                      onClick={() => handleEdit(item)}
                    >
                      <i className="bi bi-pencil-fill"></i>
                    </button>
                    <button
                      className="action-btn delete-action"
                      onClick={() => handleDelete(item.id)}
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  </div>

                  <div className="mt-2 mb-0 time">
                    {item.status?.toLowerCase() === "pending" ? (
                      Number(item.show_ads_days) > 0 ? (
                        // Ads request already sent
                        <div
                          style={{
                            color: "#ff9800",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textAlign: "center",
                            padding: "7px",
                          }}
                        >
                          <i className="bi bi-clock-history me-1"></i>
                          Request Sent
                        </div>
                      ) : (
                        // No Ads plan selected yet
                        <button
                          className="renew-btn"
                          onClick={() => {
                            setRenewWorkspaceId(item.id);

                            setRenewData({
                              plan_id: "",
                              show_ads_days: "",
                              ads_amount: "",
                              payment_screenshot: null,
                            });

                            setRenewPopup(true);
                          }}
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Select Ads
                        </button>
                      )
                    ) : !isExpired(item) ? (
                      item.ads_end_date && (
                        <div
                          style={{
                            color: "green",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textAlign: "center",
                            alignItems: "center",
                            padding: "7px",
                          }}
                        >
                          Time Left:{" "}
                          {getTimeLeft(item.ads_end_date, item.status)}
                        </div>
                      )
                    ) : (
                      <button
                        className="renew-btn"
                        onClick={() => {
                          setRenewWorkspaceId(item.id);

                          setRenewData({
                            plan_id: "",
                            show_ads_days: "",
                            ads_amount: "",
                            payment_screenshot: null,
                          });

                          setRenewPopup(true);
                        }}
                      >
                        <i className="bi bi-arrow-clockwise me-2"></i>
                        Renew Ads
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No workspace items found.</p>
        )}
      </div>

      {/* RENEW POPUP MODAL */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Workspace Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{viewData.owner_name || "-"}</p>
              </div>

              <div>
                <label>Mobile</label>
                <p>{viewData.phone || "-"}</p>
              </div>

              <div>
                <label>City</label>
                <p>{viewData.city || "-"}</p>
              </div>
              <div>
                <label>Address</label>
                <p>{viewData.address || "-"}</p>
              </div>

              <div>
                <label>Floor</label>
                <p>{viewData.floor || "-"}</p>
              </div>

              <div>
                <label>Rent</label>
                <p>₹ {viewData.rent_price || "-"}</p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{viewData.show_ads_days || "-"}</p>
              </div>

              <div>
                <label>Payed Amount</label>
                <p>₹ {viewData.ads_amount || 0}</p>
              </div>

              {viewData.payment_screenshot && (
                <div>
                  <label>Payment:</label>

                  <img
                    src={`${UPLOADS.WORKSPACE_IMAGE}${viewData.payment_screenshot}`}
                    width="80"
                    alt="payment"
                    style={{
                      cursor: "pointer",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                    onClick={() =>
                      setPreviewImage(
                        `${UPLOADS.WORKSPACE_IMAGE}${viewData.payment_screenshot}`,
                      )
                    }
                  />
                </div>
              )}
            </div>
            {previewImage && (
              <div
                className="popup-overlay"
                onClick={() => setPreviewImage(null)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setPreviewImage(null)}
                  >
                    ✖
                  </button>

                  <img
                    src={previewImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}

            <div className="description-box">
              <label>Description</label>

              <p>{viewData.description || "-"}</p>
            </div>

            <div className="popup-images">
              {viewData.images?.map((img, i) => (
                <img
                  key={i}
                  src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                  alt="workspace"
                  style={{ cursor: "pointer" }}
                  onClick={() => openCarousel(viewData.images, i)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {renewPopup && (
        <div className="popup-overlay">
          <div className="popup-box renew-popup">
            <div className="popup-header">
              <h3>
                {workspace
                  .find((w) => String(w.id) === String(renewWorkspaceId))
                  ?.status?.toLowerCase() === "pending"
                  ? "Select Ads"
                  : "Renew Ads"}
              </h3>

              <button
                className="close-icon-btn"
                onClick={() => setRenewPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="workspace-grid">
              {/* PLAN */}
              <div className="workspace-field">
                <label>Select Plan</label>

                <select
                  name="show_ads_days"
                  value={renewData.plan_id || ""}
                  onChange={handleRenewChange}
                >
                  <option value="">Select Days</option>

                  {adsPlans.map((plan) => {
                    const user = JSON.parse(sessionStorage.getItem("user"));

                    const freeUsed =
                      Number(user?.workspace_free_plan_used) === 1 &&
                      Number(plan.amount) === 0;

                    return (
                      <option key={plan.id} value={plan.id} disabled={freeUsed}>
                        {plan.days} Days - ₹{plan.amount}
                        {freeUsed ? " (Already Used)" : ""}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* AMOUNT */}
              <div className="workspace-field">
                <label>Amount Pay</label>

                <input value={renewData.ads_amount} readOnly />
              </div>

              {/* QR */}
              {/* {renewData.show_ads_days && renewData.ads_amount !== "0" && (
                <div className="row" style={{ alignItems: "center" }}>
                  <div className="col-md-6">
                    <div className="workspace-field">
                      <label>Scan & Pay</label>

                      <img src="/images/qr.jpeg" width="200" alt="QR" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="workspace-field">
                      <label>Upload Payment Screenshot</label>

                      <input
                        type="file"
                        name="payment_screenshot"
                        onChange={handleRenewChange}
                      />
                    </div>
                  </div>
                </div>
              )} */}

              {/* BUTTON */}
              <div className="workspace-field">
                <button
                  className="workspace-submit"
                  onClick={handleRenewSubmit}
                >
                  Pay & Submit Ads
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {freePlanPopup && (
        <div className="beads-freeplan-overlay">
          <div className="beads-freeplan-popup">
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
                paddingBottom: "20px",
              }}
            >
              <h3 style={{ margin: "0px" }}>
                <i className="bi bi-info-circle"></i>
                Free Plan Already Used
              </h3>
              <button
                className="close-icon-btn"
                onClick={() => setFreePlanPopup(false)}
              >
                ✕
              </button>
            </div>

            <p>
              You have already used your free plan. Do you want to edit your ads
              option or send request for approval?
            </p>

            <div className="beads-freeplan-actions">
              <button
                type="button"
                className="beads-freeplan-send"
                onClick={() => {
                  setFreePlanPopup(false);

                  // allow next submit
                  setAllowFreePlanRequest(true);

                  setTimeout(() => {
                    document.querySelector(".btn-submit-workspace").click();
                  }, 100);
                }}
              >
                Send Request
              </button>

              <button
                className="beads-freeplan-edit"
                onClick={() => {
                  setFreePlanPopup(false);

                  // clear free plan selection
                  setForm((prev) => ({
                    ...prev,
                    show_ads_days: "",
                    ads_amount: "",
                  }));
                }}
              >
                Edit Ads Option
              </button>
            </div>
          </div>
        </div>
      )}
      {showCarousel && carouselImages.length > 0 && (
        <div
          className="lightbox-overlay"
          onClick={() => setShowCarousel(false)}
        >
          <div
            className="carousel-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setShowCarousel(false)}
            >
              &times;
            </button>

            {carouselImages.length > 1 && (
              <button
                className="nav-btn nav-btn-left"
                onClick={prevCarouselImage}
              >
                &#10094;
              </button>
            )}

            <img
              className="carousel-image"
              src={`${UPLOADS.WORKSPACE_IMAGE}${carouselImages[currentImageIndex]}`}
              alt="Workspace"
            />

            {carouselImages.length > 1 && (
              <button
                className="nav-btn nav-btn-right"
                onClick={nextCarouselImage}
              >
                &#10095;
              </button>
            )}

            <div className="slides-counter">
              {currentImageIndex + 1} / {carouselImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
